var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"showBtn"},[((this.$store.state.ResetrouterNavWidth!=0))?_c('img',{attrs:{"src":require("@/assets/custom-icon/leftBtn.svg")},on:{"click":_vm.hideBlock}}):_c('img',{attrs:{"src":require("@/assets/custom-icon/rightBtn.svg")},on:{"click":_vm.showBlock}})])
}
var staticRenderFns = []

export { render, staticRenderFns }